export default __webpack_public_path__ + "static/media/todo.566b076a.jpeg";